import e, { Component as t } from "react";
import r from "../../../../node_modules/classnames/index.js";
import o from "../../../utils/ObjectUtils.js";
import { InputText as n } from "./InputText.js";
import { FormLabel as i } from "../Label/FormLabel.js";
function c(e, t) {
  for (var r = 0; r < t.length; r++) {
    var o = t[r];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function s(e) {
  return (s = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function u(e, t) {
  return (u = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
var a = function (t) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && u(e, t);
  }(b, t);
  var a,
    p,
    f,
    l = (a = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }(), function () {
      var e,
        t,
        r = s(b);
      if (a) {
        var o = s(this).constructor;
        t = Reflect.construct(r, arguments, o);
      } else t = r.apply(this, arguments);
      return (e = t) && ("object" == (e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e) || "function" == typeof e) ? e : function (e) {
        if (void 0 === e) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(this);
    });
  function b() {
    return !function (e, t) {
      if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
    }(this, b), l.apply(this, arguments);
  }
  return p = [{
    key: "render",
    value: function value() {
      var t,
        c,
        s = o.omitKeys(this.props, ["className", "label", "errorMessage", "inputClass", "inputId", "required", "id"]),
        u = r("kaseya-ui-input-text-field", this.props.className);
      return e.createElement(i, {
        className: u,
        value: this.props.label,
        errorMessage: this.props.errorMessage,
        isRequired: this.props.required
      }, e.createElement(n, (t = function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = null != arguments[t] ? arguments[t] : {},
            o = Object.keys(r);
          "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function (e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
          }))), o.forEach(function (t) {
            var o;
            o = r[t], t in e ? Object.defineProperty(e, t, {
              value: o,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : e[t] = o;
          });
        }
        return e;
      }({
        hasError: !!this.props.errorMessage,
        id: this.props.inputId
      }, s), c = c = {
        className: this.props.inputClass
      }, Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(c)) : function (e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          r.push.apply(r, o);
        }
        return r;
      }(Object(c)).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(c, e));
      }), t)));
    }
  }], c(b.prototype, p), f && c(b, f), b;
}(t);
export { a as InputTextField };